/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Billing_MonthlyInputs */

const en_signup_billing_monthly = /** @type {(inputs: Signup_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

const fr_signup_billing_monthly = /** @type {(inputs: Signup_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensuel`)
};

const de_signup_billing_monthly = /** @type {(inputs: Signup_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatlich`)
};

const it_signup_billing_monthly = /** @type {(inputs: Signup_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensile`)
};

const ru_signup_billing_monthly = /** @type {(inputs: Signup_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежемесячно`)
};

const es_signup_billing_monthly = /** @type {(inputs: Signup_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensual`)
};

const zh_cn2_signup_billing_monthly = /** @type {(inputs: Signup_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月度`)
};

const ja_signup_billing_monthly = /** @type {(inputs: Signup_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎月`)
};

const hi_signup_billing_monthly = /** @type {(inputs: Signup_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`महीने के`)
};

const pt_pt2_signup_billing_monthly = /** @type {(inputs: Signup_Billing_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensal`)
};

/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {Signup_Billing_MonthlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_billing_monthly = /** @type {((inputs?: Signup_Billing_MonthlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Billing_MonthlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_billing_monthly(inputs)
	if (locale === "de") return de_signup_billing_monthly(inputs)
	if (locale === "it") return it_signup_billing_monthly(inputs)
	if (locale === "ru") return ru_signup_billing_monthly(inputs)
	if (locale === "es") return es_signup_billing_monthly(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_billing_monthly(inputs)
	if (locale === "ja") return ja_signup_billing_monthly(inputs)
	if (locale === "hi") return hi_signup_billing_monthly(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_billing_monthly(inputs)
	return en_signup_billing_monthly(inputs)
});